export default __webpack_public_path__ + "static/media/reebok_stimuli_es.bac6fa86.mp4";